import PropTypes from "prop-types";
import ArrowRight from "/public/images/icons/arrowRight.svg?react";
import MilestoneProgressBar from "../MilestoneProgressBar";
import { Link } from "react-router-dom";

export default function MilestoneCard({ milestone, selectedParticipant }) {
  const userProgress = (milestone.AwardedCount / milestone.AwardedAfterEvents) * 100;
  const userProgressString = userProgress > 100 ? "100%" : `${userProgress}%`;

  return (
    <Link to={`/milestones/${milestone.MilestoneId}`} 
      state={{ 
        milestone: milestone,
        selectedParticipant: selectedParticipant 
      }}
    >
      <div
        className={`${
          userProgress === 0 ? "opacity-50" : ""
        } bg-white rounded-[4px] border-solid border-[1px] border-[#E3E3E3] px-5 pt-5 pb-[10px]`}
        data-testid="milestone-container"
      >
        <div className="flex gap-[19px]">
          <div className="relative w-[52px] height-[71px]">
            {(milestone.AwardedCount >= milestone.AwardedAfterEvents ||
              userProgressString === "100%") && (
              <span data-testid="milestone-complete" className="absolute top-0 left-1/2 -translate-x-1/2 bg-[#69B200] bg-[center_bottom_5px] rounded-b-[3px] w-4 h-5 bg-[url('/images/icons/tickWhite.svg')] bg-no-repeat bg-[length:8px_6.5px]"></span>
            )}
            <img
              src={milestone.MilestoneBadgeURL}
              width={52}
              height={71}
              className="block"
              alt={milestone.MilestoneName}
            />
          </div>

          <div className="flex flex-col flex-grow">
            <div className="flex justify-between items-center">
              <p className="font-semibold text-base leading-[26px] text-[#1E1E1E]">
                {milestone.MilestoneName}
              </p>
              <ArrowRight className="w-[15px] h-[13.5px]" />
            </div>
            <p className="mb-[5px] text-base leading-[26px] text-[#727272]">
              {milestone.MilestoneDescription}
            </p>
            <MilestoneProgressBar progress={milestone} />
          </div>
        </div>
      </div>
    </Link>
  );
}

MilestoneCard.propTypes = {
  milestone: PropTypes.shape().isRequired,
}
